module.exports = __webpack_public_path__ + "static/media/set-chop-lines-blockify_small.123c1c5d.mp4";